import BaseMystery from '../BaseMystery'

const ThirdJoyfulMystery = () => {
	const imagesList = [
		"https://www.wga.hu/art/a/agabiti/natavit1.jpg",
		"https://www.wga.hu/art/a/agabiti/altar34.jpg",
		"https://www.wga.hu/art/a/altdorfe/2/03nativi.jpg",
		"https://www.wga.hu/art/a/anguier/michel/nativity.jpg",
		"https://www.wga.hu/art/a/antoniaz/nativity.jpg",
		"https://www.wga.hu/art/b/backerde/nativity.jpg",
		"https://www.wga.hu/art/b/baldung/2/08nativi.jpg",
		"https://www.wga.hu/art/b/barnaba/fragmen3.jpg",
		"https://www.wga.hu/art/b/barocci/nativity.jpg",
		"https://www.wga.hu/art/b/bartolo/panel1.jpg",
		"https://www.wga.hu/art/b/bicci/lorenzo/nativity.jpg",
		"https://www.wga.hu/art/b/bicci/neri/nativit.jpg",
		"https://www.wga.hu/art/b/botticel/91late/130nativi.jpg",
		"https://www.wga.hu/art/c/caravagg/11/68nativi.jpg",
		"https://www.wga.hu/art/c/cavallin/mosaic/3scene.jpg",
		"https://www.wga.hu/art/c/christus/1/annuncib.jpg",
		"https://www.wga.hu/art/c/codazzi/nativit.jpg",
		"https://www.wga.hu/art/c/correggi/various/nativity.jpg",
		"https://www.wga.hu/art/c/correggi/madonna/night.jpg",
		"https://www.wga.hu/art/c/costa/lorenzo/nativity.jpg",
		"https://www.wga.hu/art/c/cranach/lucas_e/05/41religi.jpg",
		"https://www.wga.hu/art/d/daddi/nativity.jpg",
		"https://www.wga.hu/art/d/david/1/nativit.jpg",
		"https://www.wga.hu/art/d/david/1/nativity.jpg",
		"https://www.wga.hu/art/d/david/1/triptic1.jpg",
		"https://www.wga.hu/art/d/diamante/nativity.jpg",
		"https://www.wga.hu/art/d/dossi/battista/nativity.jpg",
		"https://www.wga.hu/art/d/duccio/maesta/predel_f/pre_f_2.jpg",
		"https://www.wga.hu/art/f/fasolo/nativity.jpg",
		"https://www.wga.hu/art/f/ferrari/defenden/nativity.jpg",
		"https://www.wga.hu/art/f/francesc/3paintin/2nativi.jpg",
		"https://www.wga.hu/art/g/geertgen/nativity.jpg",
		"https://www.wga.hu/art/g/ghirland/domenico/7panel/13nativi.jpg",
		"https://www.wga.hu/art/g/ghirland/domenico/7panel/111nativ.jpg",
		"https://www.wga.hu/art/g/giotto/assisi/lower/ceiling/02christ.jpg",
		"https://www.wga.hu/art/g/giotto/padova/3christ/chris01.jpg",
		"https://www.wga.hu/art/g/giovanni/frances/nativit.jpg",
	];

	const scriptureQuote = "While they were there, the time came for her to have her child, and she gave birth to her firstborn son. She wrapped him in swaddling clothes and laid him in a manger, because there was no room for them in the inn.";
	const scriptureCitation = "Luke 2:6-7 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=Luke%202%3A4-17&version=NABRE";

	return (
		<BaseMystery titleText="The Birth of Our Lord"
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={false} />
	);
};

export default ThirdJoyfulMystery;